import {inject, Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { ITranslationDataInterface } from "./translation-data.interface";
import { TranslationOverviewServiceModel, TranslationServiceModel } from "./models/translation-service.model";
import { ConfigurationService } from "../../shared/services/configuration.service";
import {InactiveModeService} from "../../shared/services/inactive-mode.service";

@Injectable({
    providedIn: 'root'
})
export class TranslationDataService implements ITranslationDataInterface {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigurationService);
    private readonly inactiveMode = inject(InactiveModeService);

    private readonly api = this.config.configuration.api.backendUrl
    private readonly baseEndpoint = 'configuration/settings'

    private get endpoint(): string {
        return this.inactiveMode.inactiveMode
            ? 'configuration/all-settings'
            : 'configuration/settings';
    }

    getTranslations(): Observable<TranslationServiceModel[]> {
        return this.http.get<TranslationServiceModel[]>(`${this.api}/${this.endpoint}`);
    }

    getTranslationsOverview(): Observable<TranslationOverviewServiceModel[]> {
        return this.http.get<TranslationOverviewServiceModel[]>(`${this.api}/${this.endpoint}`);
    }

    getTranslation(id: number): Observable<TranslationServiceModel> {
        return this.http.get<TranslationServiceModel>(`${this.api}/${this.endpoint}/${id}`);
    }

    createTranslation(translation: TranslationServiceModel): Observable<TranslationServiceModel> {
        return this.http.post<TranslationServiceModel>(`${this.api}/${this.baseEndpoint}`, translation);
    }

    updateTranslation(translation: TranslationServiceModel): Observable<TranslationServiceModel> {
        return this.http.put<TranslationServiceModel>(`${this.api}/${this.baseEndpoint}/${translation.id}`, translation);
    }

    deleteTranslation(id: number): Observable<boolean> {
        return this.http.delete<boolean>(`${this.api}/${this.baseEndpoint}/${id}`);
    }

    searchTranslations(name: string, search: string): Observable<any[]> {
        return this.http.get<any>(`${this.api}/${this.endpoint}/search/searchTranslations?name=${name}&search=${search}`).pipe(
            map((response: any) => response._embedded.settings)
        );
    }
}